export const FEATURE_FLAGS = Object.freeze({
  ACCESS_GROUPS: 'access-groups-enabled',
  ACCESS_POLICIES: 'access-policies-enabled',
  SETTINGS: 'settings-enabled'
})
